<template>
  <v-alert
    :border="border || 'start'"
    density="compact"
    variant="outlined"
    colored-border
  >
    <slot />

    <template v-for="(_, name) in $slots" #[name]="scope">
      <slot :name v-bind="scope ?? {}"/>
    </template>
  </v-alert>
</template>

<script setup lang="ts">
import type { VAlert } from 'vuetify/components';

defineProps<{
  border?: VAlert['border'];
}>();
</script>

<style scoped>
:deep(.v-alert__content) {
  color: #333;
}
</style>